import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { EffyButtonComponent } from '@effy-tech/angular-common/button';
import { EffyLinkComponent } from '@effy-tech/angular-common/link';
import { WidgetFormNavigationService } from '../widget-form-navigation.service';

@Component({
  selector: 'nscf-widget-form-work-step-layout',
  imports: [EffyButtonComponent, EffyLinkComponent, MatIcon, ReactiveFormsModule],
  template: `
    <button effy-link (click)="navigationService.prev()">
      <mat-icon class="flex items-center" svgIcon="chevron-left" />
      <span class="text-sm slg:text-md">Précédent</span>
    </button>
    <form class="mt-8 grow flex flex-col gap-6" [formGroup]="form()" (ngSubmit)="ngSubmit.emit()">
      <div class="grow flex flex-col gap-6">
        <ng-content />
      </div>
      <button effy-button [attr.aria-disabled]="form().invalid" type="submit" class="mt-auto w-full">
        <span>Suivant</span>
        <mat-icon svgIcon="chevron-right" />
      </button>
    </form>
  `,
  styles: [
    `
      :host {
        @apply grow flex flex-col;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetFormWorkStepLayoutComponent {
  readonly navigationService = inject(WidgetFormNavigationService);
  readonly form = input.required<FormGroup>();
  readonly ngSubmit = output<void>();
  readonly prev = output<void>();
}
